// import React, { useState } from "react";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./contactPageStyle.css";
// import {
//   FaEnvelopeOpenText,
//   FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaPaperPlane,
//   FaUserAlt,
// } from "react-icons/fa";

// const ContactPage = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [status, setStatus] = useState({ type: "", msg: "" });
//   const [submitting, setSubmitting] = useState(false);

//   const validate = () => {
//     const e = {};
//     if (!form.name.trim()) e.name = "Your name is required.";
//     if (!form.email.trim()) {
//       e.email = "Your email is required.";
//     } else {
//       const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
//       if (!emailOk) e.email = "Please enter a valid email.";
//     }
//     if (!form.phone.trim()) {
//       e.phone = "Your number is required.";
//     } else {
//       const phoneOk = /^[0-9+\-\s()]{6,20}$/.test(form.phone);
//       if (!phoneOk) e.phone = "Please enter a valid phone number.";
//     }
//     if (!form.message.trim()) e.message = "Please write your message.";
//     return e;
//   };

//   const handleChange = (ev) => {
//     const { name, value } = ev.target;
//     setForm((f) => ({ ...f, [name]: value }));
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: undefined }));
//     }
//   };

//   const handleSubmit = async (ev) => {
//     ev.preventDefault();
//     setStatus({ type: "", msg: "" });

//     const e = validate();
//     setErrors(e);
//     if (Object.keys(e).length) return;

//     try {
//       setSubmitting(true);

//       // TODO: hook this up to your backend endpoint
//       // Example:
//       // const res = await fetch(`${URL}/contact`, {
//       //   method: "POST",
//       //   headers: { "Content-Type": "application/json" },
//       //   body: JSON.stringify(form),
//       // });
//       // if (!res.ok) throw new Error("Network error");

//       // Simulate success:
//       await new Promise((r) => setTimeout(r, 800));

//       setStatus({
//         type: "success",
//         msg: "Thanks! Your message has been sent. We’ll get back to you soon.",
//       });
//       setForm({ name: "", email: "", phone: "", message: "" });
//     } catch (err) {
//       setStatus({
//         type: "error",
//         msg: "Sorry, something went wrong. Please try again.",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="contact-page">
//       <Navbar />

//       {/* HERO */}
//       <section className="contact-hero">
//         <div className="contact-container">
//           <h1 className="contact-title">Have a Query? Contact Us!</h1>
//           <p className="contact-subtitle">
//             Any questions, issues, or improvement feedback — we’re here to help.
//             Send us a message and our team will respond shortly.
//           </p>
//         </div>
//       </section>

//       {/* CONTENT */}
//       <section className="contact-section">
//         <div className="contact-container contact-grid">
//           {/* Info / Quick Contact */}
//           <aside className="contact-info-card">
//             <h2 className="card-title">
//               <FaEnvelopeOpenText className="card-title-icon" />
//               Quick Contact
//             </h2>
//             <p className="card-text">
//               Reach out with any service queries, booking issues, or suggestions
//               to improve HelpNao. We value your feedback!
//             </p>

//             <div className="contact-items">
//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaPhoneAlt />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Call</p>
//                   <p className="contact-item-value">+880 1XXX-XXXXXX</p>
//                 </div>
//               </div>

//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaEnvelopeOpenText />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Email</p>
//                   <p className="contact-item-value">support@HelpNao.app</p>
//                 </div>
//               </div>

//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaMapMarkerAlt />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Location</p>
//                   <p className="contact-item-value">Mirpur, Dhaka, Bangladesh</p>
//                 </div>
//               </div>
//             </div>

//             <div className="contact-mini-note">
//               <FaUserAlt />
//               <span>Business hours: 9:00–18:00 (BST), Sun–Thu</span>
//             </div>
//           </aside>

//           {/* Form */}
//           <div className="contact-form-card">
//             <h2 className="card-title">
//               <FaPaperPlane className="card-title-icon" />
//               Send Your Message
//             </h2>

//             {status.msg && (
//               <div
//                 className={`form-status ${
//                   status.type === "success" ? "ok" : "err"
//                 }`}
//                 role="status"
//                 aria-live="polite"
//               >
//                 {status.msg}
//               </div>
//             )}

//             <form className="contact-form" onSubmit={handleSubmit} noValidate>
//               {/* Name */}
//               <div className={`form-field ${errors.name ? "has-error" : ""}`}>
//                 <label htmlFor="name">Your Name *</label>
//                 <input
//                   id="name"
//                   name="name"
//                   type="text"
//                   value={form.name}
//                   onChange={handleChange}
//                   placeholder="Enter your full name"
//                   required
//                   autoComplete="name"
//                 />
//                 {errors.name && (
//                   <p className="field-error" role="alert">
//                     {errors.name}
//                   </p>
//                 )}
//               </div>

//               {/* Email */}
//               <div className={`form-field ${errors.email ? "has-error" : ""}`}>
//                 <label htmlFor="email">Your Email *</label>
//                 <input
//                   id="email"
//                   name="email"
//                   type="email"
//                   value={form.email}
//                   onChange={handleChange}
//                   placeholder="you@example.com"
//                   required
//                   autoComplete="email"
//                 />
//                 {errors.email && (
//                   <p className="field-error" role="alert">
//                     {errors.email}
//                   </p>
//                 )}
//               </div>

//               {/* Phone */}
//               <div className={`form-field ${errors.phone ? "has-error" : ""}`}>
//                 <label htmlFor="phone">Your Number *</label>
//                 <input
//                   id="phone"
//                   name="phone"
//                   type="tel"
//                   value={form.phone}
//                   onChange={handleChange}
//                   placeholder="+8801XXXXXXXXX"
//                   required
//                   autoComplete="tel"
//                 />
//                 {errors.phone && (
//                   <p className="field-error" role="alert">
//                     {errors.phone}
//                   </p>
//                 )}
//               </div>

//               {/* Message */}
//               <div
//                 className={`form-field form-field--full ${
//                   errors.message ? "has-error" : ""
//                 }`}
//               >
//                 <label htmlFor="message">Your Message *</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={form.message}
//                   onChange={handleChange}
//                   placeholder="Write your query or improvement feedback here..."
//                   rows="6"
//                   required
//                 />
//                 {errors.message && (
//                   <p className="field-error" role="alert">
//                     {errors.message}
//                   </p>
//                 )}
//               </div>

//               <button
//                 type="submit"
//                 className="btn-submit"
//                 disabled={submitting}
//                 aria-busy={submitting ? "true" : "false"}
//               >
//                 {submitting ? "Sending..." : "Send Message"}
//               </button>

//               <p className="form-note">
//                 All fields are required. We respect your privacy and only use
//                 your info to respond to your request.
//               </p>
//             </form>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default ContactPage;






// import React, { useState, useMemo } from "react";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer/Footer";
// import "./contactPageStyle.css";
// import {
//   FaEnvelopeOpenText,
//   FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaPaperPlane,
//   FaUserAlt,
// } from "react-icons/fa";
// import { URL } from "../../config";

// const ContactPage = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//     website: "", // honeypot
//   });

//   const [errors, setErrors] = useState({});
//   const [status, setStatus] = useState({ type: "", msg: "" });
//   const [submitting, setSubmitting] = useState(false);

//   // --- client daily lock (soft UX; server still enforces)
//   const lastSentAt = useMemo(() => {
//     const raw = localStorage.getItem("contactLastSentAt");
//     return raw ? new Date(raw) : null;
//   }, []);

//   const isToday = (d) => {
//     if (!d) return false;
//     const now = new Date();
//     return (
//       d.getFullYear() === now.getFullYear() &&
//       d.getMonth() === now.getMonth() &&
//       d.getDate() === now.getDate()
//     );
//   };

//   const clientLockedForToday = isToday(lastSentAt);

//   const validate = () => {
//     const e = {};
//     if (!form.name.trim()) e.name = "Your name is required.";
//     if (!form.email.trim()) {
//       e.email = "Your email is required.";
//     } else {
//       const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
//       if (!emailOk) e.email = "Please enter a valid email.";
//     }
//     if (!form.phone.trim()) {
//       e.phone = "Your number is required.";
//     } else {
//       const phoneOk = /^[0-9+\-\s()]{6,20}$/.test(form.phone);
//       if (!phoneOk) e.phone = "Please enter a valid phone number.";
//     }
//     if (!form.message.trim()) e.message = "Please write your message.";
//     return e;
//   };

//   const handleChange = (ev) => {
//     const { name, value } = ev.target;
//     setForm((f) => ({ ...f, [name]: value }));
//     if (errors[name]) {
//       setErrors((prev) => ({ ...prev, [name]: undefined }));
//     }
//   };

//   const handleSubmit = async (ev) => {
//     ev.preventDefault();
//     setStatus({ type: "", msg: "" });

//     if (clientLockedForToday) {
//       setStatus({
//         type: "error",
//         msg: "You have already sent a message today. Please try again tomorrow.",
//       });
//       return;
//     }

//     const e = validate();
//     setErrors(e);
//     if (Object.keys(e).length) return;

//     try {
//       setSubmitting(true);

//       const res = await fetch(`${URL}/contact`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       const data = await res.json().catch(() => ({}));

//       if (!res.ok) {
//         // if server enforces daily lock
//         if (res.status === 429) {
//           // store local lock for UX
//           localStorage.setItem("contactLastSentAt", new Date().toISOString());
//           setStatus({
//             type: "error",
//             msg:
//               data?.error ||
//               "You have already submitted a message today. Please try again tomorrow.",
//           });
//           return;
//         }
//         setStatus({
//           type: "error",
//           msg: data?.error || "Sorry, something went wrong. Please try again.",
//         });
//         return;
//       }

//       // success
//       localStorage.setItem("contactLastSentAt", new Date().toISOString());
//       setStatus({
//         type: "success",
//         msg: "Thanks! Your message has been sent. We’ll get back to you soon.",
//       });
//       setForm({ name: "", email: "", phone: "", message: "", website: "" });
//     } catch (err) {
//       setStatus({
//         type: "error",
//         msg: "Sorry, something went wrong. Please try again.",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="contact-page">
//       <Navbar />

//       {/* HERO */}
//       <section className="contact-hero">
//         <div className="contact-container">
//           <h1 className="contact-title">Have a Query? Contact Us!</h1>
//           <p className="contact-subtitle">
//             Any questions, issues, or improvement feedback — we’re here to help.
//             Send us a message and our team will respond shortly.
//           </p>
//         </div>
//       </section>

//       {/* CONTENT */}
//       <section className="contact-section">
//         <div className="contact-container contact-grid">
//           {/* Info / Quick Contact */}
//           <aside className="contact-info-card">
//             <h2 className="card-title">
//               <FaEnvelopeOpenText className="card-title-icon" />
//               Quick Contact
//             </h2>
//             <p className="card-text">
//               Reach out with any service queries, booking issues, or suggestions
//               to improve HelpNao. We value your feedback!
//             </p>

//             <div className="contact-items">
//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaPhoneAlt />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Call</p>
//                   <p className="contact-item-value">+880 1XXX-XXXXXX</p>
//                 </div>
//               </div>

//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaEnvelopeOpenText />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Email</p>
//                   <p className="contact-item-value">support@HelpNao.app</p>
//                 </div>
//               </div>

//               <div className="contact-item">
//                 <div className="contact-item-icon">
//                   <FaMapMarkerAlt />
//                 </div>
//                 <div className="contact-item-body">
//                   <p className="contact-item-label">Location</p>
//                   <p className="contact-item-value">Mirpur, Dhaka, Bangladesh</p>
//                 </div>
//               </div>
//             </div>

//             <div className="contact-mini-note">
//               <FaUserAlt />
//               <span>Business hours: 9:00–18:00 (BST), Sun–Thu</span>
//             </div>
//           </aside>

//           {/* Form */}
//           <div className="contact-form-card">
//             <h2 className="card-title">
//               <FaPaperPlane className="card-title-icon" />
//               Send Your Message
//             </h2>

//             {status.msg && (
//               <div
//                 className={`form-status ${
//                   status.type === "success" ? "ok" : "err"
//                 }`}
//                 role="status"
//                 aria-live="polite"
//               >
//                 {status.msg}
//               </div>
//             )}

//             <form className="contact-form" onSubmit={handleSubmit} noValidate>
//               {/* Honeypot (hidden) */}
//               <input
//                 type="text"
//                 name="website"
//                 value={form.website}
//                 onChange={handleChange}
//                 style={{ display: "none" }}
//                 tabIndex={-1}
//                 autoComplete="off"
//               />

//               {/* Name */}
//               <div className={`form-field ${errors.name ? "has-error" : ""}`}>
//                 <label htmlFor="name">Your Name *</label>
//                 <input
//                   id="name"
//                   name="name"
//                   type="text"
//                   value={form.name}
//                   onChange={handleChange}
//                   placeholder="Enter your full name"
//                   required
//                   autoComplete="name"
//                 />
//                 {errors.name && (
//                   <p className="field-error" role="alert">
//                     {errors.name}
//                   </p>
//                 )}
//               </div>

//               {/* Email */}
//               <div className={`form-field ${errors.email ? "has-error" : ""}`}>
//                 <label htmlFor="email">Your Email *</label>
//                 <input
//                   id="email"
//                   name="email"
//                   type="email"
//                   value={form.email}
//                   onChange={handleChange}
//                   placeholder="you@example.com"
//                   required
//                   autoComplete="email"
//                 />
//                 {errors.email && (
//                   <p className="field-error" role="alert">
//                     {errors.email}
//                   </p>
//                 )}
//               </div>

//               {/* Phone */}
//               <div className={`form-field ${errors.phone ? "has-error" : ""}`}>
//                 <label htmlFor="phone">Your Number *</label>
//                 <input
//                   id="phone"
//                   name="phone"
//                   type="tel"
//                   value={form.phone}
//                   onChange={handleChange}
//                   placeholder="+8801XXXXXXXXX"
//                   required
//                   autoComplete="tel"
//                 />
//                 {errors.phone && (
//                   <p className="field-error" role="alert">
//                     {errors.phone}
//                   </p>
//                 )}
//               </div>

//               {/* Message */}
//               <div
//                 className={`form-field form-field--full ${
//                   errors.message ? "has-error" : ""
//                 }`}
//               >
//                 <label htmlFor="message">Your Message *</label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={form.message}
//                   onChange={handleChange}
//                   placeholder="Write your query or improvement feedback here..."
//                   rows="6"
//                   required
//                 />
//                 {errors.message && (
//                   <p className="field-error" role="alert">
//                     {errors.message}
//                   </p>
//                 )}
//               </div>

//               <button
//                 type="submit"
//                 className="btn-submit"
//                 disabled={submitting || clientLockedForToday}
//                 aria-busy={submitting ? "true" : "false"}
//                 title={
//                   clientLockedForToday
//                     ? "You already sent a message today."
//                     : undefined
//                 }
//               >
//                 {submitting
//                   ? "Sending..."
//                   : clientLockedForToday
//                   ? "Already Sent Today"
//                   : "Send Message"}
//               </button>

//               <p className="form-note">
//                 All fields are required. We respect your privacy and only use
//                 your info to respond to your request.
//               </p>
//             </form>
//           </div>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default ContactPage;











import React, { useState, useMemo } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import "./contactPageStyle.css";
import {
  FaEnvelopeOpenText,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaUserAlt,
} from "react-icons/fa";
import { URL } from "../../config";
import { useTranslation } from "react-i18next";
import SEO from "../../Components/SEO/SEO";

const ContactPage = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    website: "", // honeypot
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [submitting, setSubmitting] = useState(false);

  // --- client daily lock (soft UX; server still enforces)
  const lastSentAt = useMemo(() => {
    const raw = localStorage.getItem("contactLastSentAt");
    return raw ? new Date(raw) : null;
  }, []);

  const isToday = (d) => {
    if (!d) return false;
    const now = new Date();
    return (
      d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() &&
      d.getDate() === now.getDate()
    );
  };

  const clientLockedForToday = isToday(lastSentAt);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = t("contact.validation.name_required");

    if (!form.email.trim()) {
      e.email = t("contact.validation.email_required");
    } else {
      const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
      if (!emailOk) e.email = t("contact.validation.email_invalid");
    }

    if (!form.phone.trim()) {
      e.phone = t("contact.validation.phone_required");
    } else {
      const phoneOk = /^[0-9+\-\s()]{6,20}$/.test(form.phone);
      if (!phoneOk) e.phone = t("contact.validation.phone_invalid");
    }

    if (!form.message.trim()) e.message = t("contact.validation.message_required");
    return e;
  };

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setStatus({ type: "", msg: "" });

    if (clientLockedForToday) {
      setStatus({
        type: "error",
        msg: t("contact.status.daily_limit_client"),
      });
      return;
    }

    const e = validate();
    setErrors(e);
    if (Object.keys(e).length) return;

    try {
      setSubmitting(true);

      const res = await fetch(`${URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        // if server enforces daily lock
        if (res.status === 429) {
          // store local lock for UX
          localStorage.setItem("contactLastSentAt", new Date().toISOString());
          setStatus({
            type: "error",
            msg:
              data?.error || t("contact.status.daily_limit_server"),
          });
          return;
        }
        setStatus({
          type: "error",
          msg: data?.error || t("contact.status.generic_error"),
        });
        return;
      }

      // success
      localStorage.setItem("contactLastSentAt", new Date().toISOString());
      setStatus({
        type: "success",
        msg: t("contact.status.success"),
      });
      setForm({ name: "", email: "", phone: "", message: "", website: "" });
    } catch (err) {
      setStatus({
        type: "error",
        msg: t("contact.status.generic_error"),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">

      <SEO
        title="Contact HelpNao | Support & Partnerships"
        description="Contact HelpNao for support, service questions, feedback, or business partnerships."
        path="/contact"
      />

      <Navbar />

      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-container">
          <h1 className="contact-title">{t("contact.hero.title")}</h1>
          <p className="contact-subtitle">{t("contact.hero.subtitle")}</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="contact-section">
        <div className="contact-container contact-grid">
          {/* Info / Quick Contact */}
          <aside className="contact-info-card">
            <h2 className="card-title">
              <FaEnvelopeOpenText className="card-title-icon" />
              {t("contact.info.card_title")}
            </h2>
            <p className="card-text">
              {t("contact.info.card_text")}
            </p>

            <div className="contact-items">
              <div className="contact-item">
                <div className="contact-item-icon">
                  <FaPhoneAlt />
                </div>
                <div className="contact-item-body">
                  <p className="contact-item-label">
                    {t("contact.info.call_label")}
                  </p>
                  <p className="contact-item-value">
                    {t("contact.info.call_value")}
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <FaEnvelopeOpenText />
                </div>
                <div className="contact-item-body">
                  <p className="contact-item-label">
                    {t("contact.info.email_label")}
                  </p>
                  <p className="contact-item-value">
                    {t("contact.info.email_value")}
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-item-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-item-body">
                  <p className="contact-item-label">
                    {t("contact.info.location_label")}
                  </p>
                  <p className="contact-item-value">
                    {t("contact.info.location_value")}
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-mini-note">
              <FaUserAlt />
              <span>{t("contact.info.business_hours")}</span>
            </div>
          </aside>

          {/* Form */}
          <div className="contact-form-card">
            <h2 className="card-title">
              <FaPaperPlane className="card-title-icon" />
              {t("contact.form.card_title")}
            </h2>

            {status.msg && (
              <div
                className={`form-status ${
                  status.type === "success" ? "ok" : "err"
                }`}
                role="status"
                aria-live="polite"
              >
                {status.msg}
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              {/* Honeypot (hidden) */}
              <input
                type="text"
                name="website"
                value={form.website}
                onChange={handleChange}
                style={{ display: "none" }}
                tabIndex={-1}
                autoComplete="off"
              />

              {/* Name */}
              <div className={`form-field ${errors.name ? "has-error" : ""}`}>
                <label htmlFor="name">{t("contact.form.label_name")} *</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={form.name}
                  onChange={handleChange}
                  placeholder={t("contact.form.placeholder_name")}
                  required
                  autoComplete="name"
                />
                {errors.name && (
                  <p className="field-error" role="alert">
                    {errors.name}
                  </p>
                )}
              </div>

              {/* Email */}
              <div className={`form-field ${errors.email ? "has-error" : ""}`}>
                <label htmlFor="email">{t("contact.form.label_email")} *</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder={t("contact.form.placeholder_email")}
                  required
                  autoComplete="email"
                />
                {errors.email && (
                  <p className="field-error" role="alert">
                    {errors.email}
                  </p>
                )}
              </div>

              {/* Phone */}
              <div className={`form-field ${errors.phone ? "has-error" : ""}`}>
                <label htmlFor="phone">{t("contact.form.label_phone")} *</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder={t("contact.form.placeholder_phone")}
                  required
                  autoComplete="tel"
                />
                {errors.phone && (
                  <p className="field-error" role="alert">
                    {errors.phone}
                  </p>
                )}
              </div>

              {/* Message */}
              <div
                className={`form-field form-field--full ${
                  errors.message ? "has-error" : ""
                }`}
              >
                <label htmlFor="message">
                  {t("contact.form.label_message")} *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder={t("contact.form.placeholder_message")}
                  rows="6"
                  required
                />
                {errors.message && (
                  <p className="field-error" role="alert">
                    {errors.message}
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="btn-submit"
                disabled={submitting || clientLockedForToday}
                aria-busy={submitting ? "true" : "false"}
                title={
                  clientLockedForToday
                    ? t("contact.form.already_sent_title")
                    : undefined
                }
              >
                {submitting
                  ? t("contact.form.button_sending")
                  : clientLockedForToday
                  ? t("contact.form.button_already_sent")
                  : t("contact.form.button_submit")}
              </button>

              <p className="form-note">
                {t("contact.form.note")}
              </p>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
